/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {DictionaryItem} from '../models/DictionaryItem';
import type {Error} from '../models/Error';

export interface GetInitiatorSystems$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getInitiatorSystemsRequest = createAction<PayloadData<void>>('GET_INITIATOR_SYSTEMS__GET_INITIATOR_SYSTEMS__REQUEST');
export const getInitiatorSystemsSuccess = createAction<PayloadData<Array<DictionaryItem>>>('GET_INITIATOR_SYSTEMS__GET_INITIATOR_SYSTEMS__SUCCESS');
export const getInitiatorSystemsFailure = createAction<PayloadData<Error, void, true>>('GET_INITIATOR_SYSTEMS__GET_INITIATOR_SYSTEMS__FAILURE');

export const getInitiatorSystemsActions = [
    getInitiatorSystemsRequest,
    getInitiatorSystemsSuccess,
    getInitiatorSystemsFailure
] as const;

/**
 * Get all unique initiator systems from the change log
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getInitiatorSystems = (config?: GetInitiatorSystems$Config) => {
    return {
        CALL_API: {
            types: getInitiatorSystemsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/initiator-systems`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

